import React, { useEffect } from "react";
import { Heading } from "../../design/heading";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../design/table";
import LoadingView from "../../components/LoadingView";
import ErrorView from "../../components/ErrorView";
import { useMatter } from "../../contexts/MatterContext";
import MatterListItem from "./components/MatterListItem";
import CreateMatterButton from "./components/CreateMatterButton";

const MatterListPage: React.FC = () => {
  const { matters, loading, error } = useMatter();

  if (loading.list) {
    return <LoadingView title="Loading Matters" />;
  }
  if (error.list) {
    return <ErrorView error={error.list} />;
  }

  return (
    <>
      <div className="flex items-center justify-between">
        <Heading>Matter</Heading>
        <CreateMatterButton />
      </div>
      {matters.length === 0 && (
        <div className="mt-8 text-center">
          <Heading>No Matter found</Heading>
        </div>
      )}
      {matters.length > 0 && (
        <Table className="mt-8 [--gutter:theme(spacing.6)] lg:[--gutter:theme(spacing.10)]">
          <TableHead>
            <TableRow>
              <TableHeader>Name</TableHeader>
              <TableHeader>Type</TableHeader>
              <TableHeader>Members</TableHeader>
              <TableHeader>Updated At</TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {matters.map((matter) => (
              <MatterListItem key={matter._id} matter={matter} />
            ))}
          </TableBody>
        </Table>
      )}
    </>
  );
};

export default MatterListPage;
